<template>

  <div class="index">
    <div class="index-header">
      <div class="index-banner">
        <img src="../assets/img/home/img_banner.png" />
      </div>
    </div>
    <div class="grid">
      <div class="grid-body">
        <div class="grid-body-item" @click="toResult">
          <img src="../assets/icon/home/icon_fwcx.png" />
          <span>防伪查询</span>
        </div>
        <div class="grid-body-item" @click="toActivity">
          <img src="../assets/icon/home/icon_gfhd.png" />
          <span>最新活动</span>
        </div>
        <div class="grid-body-item" @click="toAwardLog">
          <img src="../assets/icon/home/icon_kpjl.png" />
          <span>中奖记录</span>
        </div>
        <div class="grid-body-item" @click="showShopChang">
          <img src="../assets/icon/home/icon_zxsc.png" />
          <span>在线商城</span>
        </div>
        <div class="grid-body-item" @click="toIntegral">
          <img src="../assets/icon/home/icon_jfsc.png">
          <span>积分商城</span>
        </div>
        <div class="grid-body-item" @click="toShopIndex">
          <img src="../assets/icon/home/icon_fjmd.png" />
          <span>附近门店</span>
        </div>
        <div class="grid-body-item" @click="toDecapRecord">
          <img src="../assets/icon/home/icon_kpjl.png" />
          <span>开瓶记录</span>
        </div>
        <div class="grid-body-item" @click="toUser">
          <img src="../assets/icon/home/icon_grzx.png">
          <span>个人中心</span>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="grid-title">联系我们</div>
      <div class="grid-body">
        <div class="grid-body-item" @click="showPublic = true">
          <img src="../assets/icon/home/icon_gzh.png">
          <span>公众号</span>
        </div>
        <div class="grid-body-item">
          <img src="../assets/icon/home/icon_lxwm.png">
          <a href="tel:4000039990">联系我们</a>
        </div>
        <!-- <div class="grid-body-item" @click="toReport">
          <img src="../assets/icon/icons8-police_station@2x.png">
          <span>用户反馈</span>
        </div> -->

      </div>
    </div>
    <div class="index-logo">
      <img src="../assets/img/logo.png">
    </div>
    <Overlay :Show="showResult">
      <div class="index-scanqr">
        <div class="index-scanqr__title">
          <div class="">防伪查询</div>
          <img src="../assets/img/icon_close.png" alt="" @click="close">
        </div>
        <div class="index-scanqr__content">即将打开扫一扫界面，请对准瓶盖二维码扫码识别
          系统将会进行防伪信息查询，更有机会获得大奖</div>
        <div class="index-scanqr__btn" @click="scanQRcode()">立即扫描（{{ count }}秒）</div>
      </div>
    </Overlay>

    <Overlay :Show="showShop">
      <div class="index-scanqr">
        <div class="index-scanqr__title">
          <div class="">温馨提示</div>
          <img src="../assets/img/icon_close.png" alt="" @click="close">
        </div>
        <div class="index-scanqr__content">您即将进入 国花瓷西凤酒 京东自营店铺，请您注意提醒</div>
        <div class="index-scanqr__btn" @click="toShop()">立刻跳转（{{ count }}秒）</div>
      </div>
    </Overlay>

    <Overlay :Show="showPublic">
      <div class="index-scanqr">
        <div class="index-scanqr__title">
          <div class=""></div>
          <img src="../assets/img/icon_close.png" alt="" @click="close">
        </div>
        <div class="index-scanqr__content">长按二维码关注</div>
        <img class="index-public" src="../assets/img/img_qrcode.png">
      </div>
    </Overlay>


    <!-- <div >
      <van-popup class="mp-popup" v-model="showPublic">
        <p>长按二维码关注</p>
        <img src="../assets/img/img_qrcode.png">
      </van-popup>
      <div class="friend-link-wrapper">
        <a href="https://ddma.vip">点点二维码</a>
        <a href="http://qumahudong.com">趣码互动</a>
      </div>
    </div>  -->
  </div>

</template>

<script>

import Vue from 'vue'
import { Toast } from 'vant'
import { Popup } from 'vant'
import { mapGetters } from 'vuex'
import { Dialog } from 'vant'
import store from '@/store'
import Config from '@/config/config'
import Overlay from '@/components/overlay.vue'

Vue.use(Popup)
Vue.use(Toast)
Vue.use(Dialog)

export default {
  data() {
    return {
      showPublic: false,
      showResult: false,
      showShop: false,
      count: 5,
      interval: null
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  components: {
    Overlay
  },
  created() {
  },
  methods: {
    toResult() {
      var that = this
      this.showResult = true
      this.interval = setInterval(function() {
        if (that.count > 0) {
          that.count--
          return
        }
        // that.$router.push({ path: '/qrcode/result', query: {} })
        that.scanQRcode()
      }, 1000)
    },
    scanQRcode() {
      var that = this
      this.close()
      this.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          // Dialog({ message: JSON.stringify(res) })
          var url = res.resultStr
          // var url = 'https://guohuaci.qumahudong.com/7n.4A3B5EPVJzDjg69Gc'; //测试
          // TODO 使用正则匹配
          if (url.indexOf(Config.baseUrl) > -1) {
            var serial = url.replace(Config.baseUrl, '').replace('/', '')
            const payload = { serial: serial }
            store.dispatch('scanQrcode', payload).then(() => {
              that.$router.push({ path: '/qrcode/result', query: { serial: serial }})
            }).catch(err => {
              that.$router.push({ name: 'QrcodeError', params: { errMsg: err.message }})
            })
          } else {
            Toast('不是有效的防伪码')
          }
        },
        fail(e) {
          Dialog({ message: '扫码失败' })
        }
      })
    },
    close() {
      this.showResult = false
      this.showShop = false
      this.showPublic = false
      this.count = 5
      clearInterval(this.interval)
    },
    toUser() {
      this.$router.push({ name: 'User' })
    },
    toActivity() {
      this.$router.push({ name: 'Activity' })
    },
    toDecapRecord() {
      this.$router.push({ name: 'DecapRecord' })
    },
    toShopIndex() {
      this.$router.push({ name: 'ShopIndex' })
    },
    toShop() {
      this.close()
      window.location.href = 'https://guohuaci.jd.com'
    },
    showShopChang() {
      var that = this
      this.showShop = true
      this.interval = setInterval(function() {
        if (that.count > 0) {
          that.count--
          return
        }
        that.toShop()
      }, 1000)
    },
    toIntegral() {
      if (this.userInfo.id) {
        const storeUrl = Config.creditStoreBaseUrl + '/?name=' + this.userInfo.nickname + '&gender=' + this.userInfo.gender +
          '&province=' + this.userInfo.province + '&city=' + this.userInfo.city + '&avatar=' + this.userInfo.avatar +
          '&userCode=' + this.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&phone=' + this.userInfo.mobile
        window.location.href = storeUrl
      }
    },
    toAwardLog() {
      this.$router.push({ name: 'AwardLog' })
    },
    toReport() {
      this.$router.push({ name: 'Report' })
    },
    /**
     * 去签到
     */
    toSign() {
      if (this.userInfo.id) {
        const signUrl = Config.creditStoreBaseUrl + '/activity/sign/?name=' + this.userInfo.nickname + '&gender=' + this.userInfo.gender +
          '&province=' + this.userInfo.province + '&city=' + this.userInfo.city + '&avatar=' + this.userInfo.avatar +
          '&userCode=' + this.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&header=true'
        window.location.href = signUrl
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.index {

  background: #F6F8FA;
  height: 233px;
  background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);

  &-logo {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    right: 16px;
    left: 16px;
    bottom: 20px;
    padding-bottom: 20px;

    img {
      width: 120px;
      height: 30px;
    }
  }

  .index-header {}

  .index-banner {
    margin-left: 10px;
    margin-right: 10px;

    img {
      margin-top: 20px;
      width: 100%;
    }
  }

  .grid {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 200px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 14px 20px;
    margin-top: 14px;
    border-radius: 16px;

    &-title {
      font-size: 17px;
      color: #000000;
      font-weight: bold;
    }

    &-body {
      display: flex;
      flex-wrap: wrap;
      gap: 14px;

      &-item {
        min-width: 21.5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;

        img {
          width: 36px;
          height: 36px;
        }

        span {
          width: 100%;
          text-align: center;
          font-size: 14px;
          color: #111827;
        }

        a {
          width: 100%;
          text-align: center;
          font-size: 14px;
          color: #111827;
        }
      }
    }
  }

  &-scanqr {
    background: #FFFFFF;
    border-radius: 16px;
    margin-left: 20px;
    margin-right: 20px;
    padding: 20px;


    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #111827;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      img {
        width: 25px;
        height: 25px;
      }
    }

    &__content {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-top: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #A0AEC0;
      line-height: 17px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    &__btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      background: #FAC859;
      box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
      border-radius: 12px;
      padding-top: 15px;
      padding-bottom: 15px;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  &-public {
    width: 250px;
    height: 250px;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue